export default {
  meta: {
    title: '点位评测-分享详情',
    url: '/spotevaluation/detail', // 埋点用，记录所属模块
  }
};
